import { render, staticRenderFns } from "./form-vincular-plano.vue?vue&type=template&id=2af8ad3b&"
import script from "./form-vincular-plano.vue?vue&type=script&lang=js&"
export * from "./form-vincular-plano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports